import { action, observable, makeObservable } from "mobx";

import { PaginatedAPIResponse } from "../models/NetworkResponse";
import OnelinkRequestAPI from "../api/OnelinkRequestAPI";
import { OnelinkRequestFilters } from "../models/Order/OnelinkRequestFilters";
import { OnelinkRequest } from "../models/Order/OnelinkRequest";

export class OnelinkRequestStore {
  onelinkRequests: OnelinkRequest[];
  onelinkRequestsAPI: OnelinkRequestAPI;
  limit: number;
  total_pages: number;
  total_count: number;

  constructor() {
    this.onelinkRequests = [];
    this.onelinkRequestsAPI = new OnelinkRequestAPI();

    this.limit = 0;
    this.total_count = 0;
    this.total_pages = 0;

    makeObservable(this, {
      onelinkRequests: observable,
      getOnelinkRequests: action,
      approveOnelinkRequest: action,
      rejectOnelinkRequest: action,
    });
  }

  getOnelinkRequests = async (filters: OnelinkRequestFilters) => {
    try {
      const response = (await this.onelinkRequestsAPI.getOnelinkRequests(
        filters
      )) as PaginatedAPIResponse<OnelinkRequest>;
      this.limit = response.limit;
      this.total_count = response.total_count;
      this.total_pages = response.total_pages;
      this.onelinkRequests = response.list;
    } catch (error: any) {
      throw error;
    }
  };

  approveOnelinkRequest = async (id: number, order_id: number) => {
    try {
      const response = await this.onelinkRequestsAPI.approveOnelinkRequest(
        id,
        order_id
      );
      const updatedOnelinkRequest = response.result.onelink_request;
      this.onelinkRequests = this.onelinkRequests.map((onelinkRequest) =>
        onelinkRequest.id === id ? updatedOnelinkRequest : onelinkRequest
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  rejectOnelinkRequest = async (id: number, order_id: number) => {
    try {
      const response = await this.onelinkRequestsAPI.rejectOnelinkRequest(
        id,
        order_id
      );
      const updatedOnelinkRequest = response.result.onelink_request;
      this.onelinkRequests = this.onelinkRequests.map((onelinkRequest) =>
        onelinkRequest.id === id ? updatedOnelinkRequest : onelinkRequest
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  };
}
